import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  Caching,
  IGenericResponseType,
} from "src/app/core/models/masterTableModels";
import { environment } from "src/environments/environment";
import { IBaseResponse } from "../app/models/App/IBaseResponse";
import { ApiRoutes } from "../app/routers/ApiRoutes";

@Injectable({
  providedIn: "root",
})
export class MasterMethodsService {
  private readonly env: string = environment.baseURL;

  constructor(private http: HttpClient) {}

  getsubIndustryActivity(
    IndustryCategories: string
  ): Observable<HttpResponse<IBaseResponse<Caching<IGenericResponseType[]>>>> {
    return this.http.post(
      this.env + ApiRoutes.MasterMethods.subIndustryActivity,
      {},
      { params: { IndustryCategories: IndustryCategories }, observe: "response" }
    );
  }
  getLineOfBusiness(
    classOfInc: string
  ): Observable<HttpResponse<IBaseResponse<Caching<IGenericResponseType[]>>>> {
    return this.http.post(
      this.env + ApiRoutes.MasterMethods.lineOfBusiness,
      {},
      { params: { ClassName: classOfInc }, observe: "response" }
    );
  }

  getClaimsTypes(
    classOfInc: string
  ): Observable<IBaseResponse<Caching<IGenericResponseType[]>>> {
    let endpoint = this.env + ApiRoutes.LookUpTables.claimCaseTypes;
    if (classOfInc.toLowerCase().includes("medical")) {
      endpoint = this.env + ApiRoutes.LookUpTables.claimCaseTypes;
    } else if (classOfInc.toLowerCase().includes("motor")) {
      endpoint = this.env + ApiRoutes.LookUpTables.motorClaimTypes;
    }

    return this.http.get(endpoint, {
      params: { ClassName: classOfInc },
    });
  }

  getClaimRequiredDocPerType(
    InsurClass: string,
    LineOfBusiness: string,
    ClaimType: string
  ) {
    return this.http.get(
      this.env + ApiRoutes.MasterMethods.getClaimRequiredDocPerType,
      {
        params: { InsurClass, LineOfBusiness, ClaimType },
      }
    );
  }

  getAllDocumentsProdction(
    policyIssueType: string
  ): Observable<HttpResponse<IBaseResponse<Caching<IGenericResponseType[]>>>> {
    return this.http.get(
      this.env + ApiRoutes.MasterMethods.getAllDocumentsProdction,
      { params: { PolicyIssueType: policyIssueType }, observe: "response" }
    );
  }

  deleteFile(data: string): Observable<HttpResponse<IBaseResponse<boolean>>> {
    return this.http.post(
      this.env + ApiRoutes.MasterMethods.deleteDocument,
      { path: data },
      { observe: "response" }
    );
  }
  downloadFile(data: string): Observable<HttpResponse<Blob>> {
    return this.http.post(
      this.env + ApiRoutes.MasterMethods.downloadDocument,
      { path: data },
      { observe: "response", responseType: "blob" }
    );
  }
  downloadAllFiles(data?: string): Observable<HttpResponse<any>> {
    return this.http.post(
      this.env + ApiRoutes.MasterMethods.downloadAll,
      { path: data },
      { observe: "response", responseType: "blob" }
    );
  }

  generateFileLink(path: string): Observable<IBaseResponse<string>> {
    return this.http.post<IBaseResponse<string>>(
      this.env + ApiRoutes.MasterMethods.generateFileLink,
      { path }
    );
  }
}
